"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var _default = function _default(_ref) {
  var title = _ref.title,
    text = _ref.text,
    bgColor = _ref.bgColor,
    color = _ref.color,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "indicator" : _ref$className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    style: {
      backgroundColor: bgColor,
      color: color
    }
  }, /*#__PURE__*/_react.default.createElement("strong", null, title), "\xA0", /*#__PURE__*/_react.default.createElement("span", null, text));
};
exports.default = _default;